// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","loadcont":"App_loadcont__bqQ4D","load":"App_load__1AsVW"};